import { getCurrentConference } from "../base/conference/functions";
import { isLocalParticipantModerator } from "../base/participants/functions";
import { SET_FLIP } from "./actionTypes";
import { ENDPOINT_MESSAGE_ASK_TO_SET_META } from "./constants";
export const setFlip = (participantIds, changeMetadata = false) => async (dispatch, getState) => {
    if (changeMetadata) {
        const conference = getCurrentConference(getState());
        if (isLocalParticipantModerator(getState())) {
            conference?.getMetadataHandler()?.setMetadata('flip', { participantIds });
        }
        else {
            conference?.sendMessage({
                type: ENDPOINT_MESSAGE_ASK_TO_SET_META,
                payload: {
                    participantIds
                }
            });
        }
    }
    return dispatch({
        type: SET_FLIP,
        payload: { participantIds }
    });
};
